export default "__VITE_ASSET__23b0f61b__"